/**
 * KAN-929: звонки клиента для ленты переписки (кабинет и /m).
 * Звонки дополняют ленту: упавший запрос даёт пустой список (и console.warn),
 * переписка показывается как была.
 * Ключ вложен в transcriptQueryKey(clientId, null): всё, что обновляет ленту
 * клиента (отправка, ручной режим, "Вернуть боту", касание бота), обновляет
 * и звонки.
 */
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { transcriptQueryKey } from '@/components/clients/useTranscriptMessages';
import { dashboardApi } from '@/services/api/dashboard';
import type { ClientCall } from '@/types/clientCall';

const NO_CALLS: ClientCall[] = [];

export function clientCallsQueryKey(clientId: string | null): readonly unknown[] {
  return [...transcriptQueryKey(clientId, null), 'calls'];
}

interface Options {
  enabled?: boolean;
  /** Перечитывать раз в N мс; false - нет. */
  refetchInterval?: number | false;
}

export function useClientCalls(
  clientId: string | null,
  { enabled = true, refetchInterval = false }: Options = {}
): ClientCall[] {
  const query = useQuery<ClientCall[]>({
    queryKey: clientCallsQueryKey(clientId),
    queryFn: () => dashboardApi.getClientCalls(clientId as string),
    enabled: enabled && !!clientId,
    refetchInterval,
    retry: false,
  });
  const { error } = query;
  useEffect(() => {
    if (error) console.warn('KAN-929: не удалось загрузить звонки клиента', error);
  }, [error]);
  return query.isError ? NO_CALLS : (query.data ?? NO_CALLS);
}
